import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { AllMeasuresUnits } from 'convert-units/definitions/all';
import { DimensionSystemService } from '../../services/dimension-system.service';
import { TransferItemUnit } from '../../../pages/transfers/enum/transfer-item-unit.enum';

@Pipe({ standalone: true, name: 'dimensionUnitConverter' })
export class DimensionUnitConverterPipe implements PipeTransform {
  private readonly DEFAULT_PRECISION_DIGITS = 2;

  constructor(
    private decimalPipe: DecimalPipe,
    private dimensionSystemService: DimensionSystemService,
  ) {}

  public transform(
    value: number,
    systemUnitDimension: string | AllMeasuresUnits | TransferItemUnit,
    precision: number = this.DEFAULT_PRECISION_DIGITS,
  ): number {
    const convertedNumber = this.dimensionSystemService.toUserMeasure(value, systemUnitDimension, precision);
    return this.decimalPipe.transform(convertedNumber) as unknown as number;
  }
}
